import { render, staticRenderFns } from "./punchImageList.vue?vue&type=template&id=012dc62c&scoped=true"
import script from "./punchImageList.vue?vue&type=script&lang=js"
export * from "./punchImageList.vue?vue&type=script&lang=js"
import style0 from "./punchImageList.vue?vue&type=style&index=0&id=012dc62c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012dc62c",
  null
  
)

export default component.exports